<template>
  <ProductsCarousel
    v-if="!loading && products.length > 0"
    :products="products"
    :loading="loading"
    :title="{ black: $t('You might also like '), red: $t(' ') }"
    title-align="left"
    background="grey"
    :carousel-settings="relatedProductsSliderSettings"
    :is-desktop="isDesktop"
  />
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import ProductsCarousel from '~/components/ProductsCarousel.vue';

export default defineComponent({
  name: 'RelatedProducts',
  components: {
    ProductsCarousel,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDesktop: Boolean,
  },
  setup() {
    const relatedProductsSliderSettings = {
      type: 'carousel',
      perView: 4,
      peek: 0,
      gap: 20,
      breakpoints: {
        767: {
          perView: 1,
          gap: 10,
          focusAt: 'center',
        },
        1023: {
          perView: 2,
          peek: 0,
          gap: 25,
        },
        1440: {
          perView: 2,
          peek: 0,
          gap: 50,
        },
        1800: {
          perView: 3,
          peek: 0,
          gap: 50,
        },
      },
    };
    return {
      relatedProductsSliderSettings,
    };
  },
});
</script>
